const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
      },
      dashboard: {
        loggedAs: "Conectado como",
        roleAdmin: "Administrador",
        roleUser: "Atendente",
        roleSuper: "Super admin",
        teamBoardTitle: "Atendimentos da equipe",
        charts: {
          perDay: {
            title: "Tickets hoje: ",
          },
        },
        messages: {
          inAttendance: {
            title: "Em Atendimento"
          },
          waiting: {
            title: "Aguardando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
        testBadge: "TESTE",
      },
      emptyState: {
        noResults: {
          title: "Nada encontrado",
          message: "Tente buscar com outro termo.",
        },
        connections: {
          title: "Conecte seu WhatsApp",
          message:
            "Conecte um número de WhatsApp para começar a receber os atendimentos dos seus clientes.",
          action: "Conectar WhatsApp",
        },
        contacts: {
          title: "Nenhum contato ainda",
          message:
            "Seus contatos aparecem aqui automaticamente quando os clientes enviam mensagem — ou cadastre um manualmente.",
          action: "Adicionar contato",
        },
        queues: {
          title: "Organize seu atendimento em filas",
          message:
            "Filas direcionam cada cliente para o setor certo, como Vendas ou Suporte.",
          action: "Criar fila",
        },
        quickAnswers: {
          title: "Crie respostas rápidas",
          message:
            "Cadastre atalhos para as mensagens que você mais envia e agilize o atendimento.",
          action: "Criar resposta rápida",
        },
        users: {
          title: "Adicione sua equipe",
          message:
            "Cadastre os atendentes que vão responder os clientes da sua empresa.",
          action: "Adicionar usuário",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          farewellMessage: "Mensagem de despedida"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          importMessage: "Deseja importas todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta Rápida",
          edit: "Editar Resposta Rápida",
        },
        form: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Resposta Rápida salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar fila",
          edit: "Editar fila",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        toasts: {
          deleted: "O ticket que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar tickets e mensagens",
        },
        buttons: {
          showAll: "Toda a equipe",
          showAllTooltip:
            "Ligado: mostra os atendimentos de todos os atendentes. Desligado: mostra apenas os seus.",
        },
      },
      testMode: {
        title: "Modo Teste",
        config: {
          title: "Configuração do teste",
          subtitle: "Simule uma conversa de cliente sem usar um WhatsApp real.",
        },
        connection: {
          label: "Conexão de teste",
          createButton: "Criar conexão de teste",
          emptyTitle: "Nenhuma conexão de teste",
          emptyDescription:
            "Crie uma conexão de teste para começar a simular conversas.",
        },
        dialog: {
          title: "Nova conexão de teste",
          description:
            "A conexão de teste já nasce conectada e serve apenas para simulações — nenhum WhatsApp real é usado.",
          nameLabel: "Nome da conexão",
          defaultName: "Conexão de Teste",
          cancel: "Cancelar",
          create: "Criar",
        },
        client: {
          sectionTitle: "Cliente simulado",
          nameLabel: "Nome do cliente",
          numberLabel: "Número do cliente",
          numberHelper: "Somente números, com DDI e DDD.",
          defaultName: "Cliente Teste",
          newClientButton: "Novo cliente",
        },
        steps: {
          title: "Como funciona",
          step1: "Escolha (ou crie) uma conexão de teste.",
          step2:
            "Envie uma mensagem como se fosse o cliente, usando o celular ao lado.",
          step3:
            "Veja o ticket chegar em Atendimentos e responda por lá — a resposta aparece na tela do celular.",
        },
        phone: {
          chip: "MODO TESTE",
          online: "online",
          noConnection: "Sem conexão",
          inputPlaceholder: "Digite uma mensagem",
          emptyTitle: "Nenhuma mensagem ainda",
          emptyDescription: "Envie a primeira mensagem para iniciar a simulação.",
          emptyNoConnection: "Nenhuma conexão selecionada",
          emptyNoConnectionHint:
            "Escolha ou crie uma conexão de teste para começar.",
        },
        toasts: {
          connectionCreated: "Conexão de teste criada com sucesso!",
          selectConnection: "Selecione uma conexão de teste antes de enviar.",
          invalidNumber: "Informe um número válido para o cliente simulado.",
        },
      },
      flydeskDevices: {
        title: "Computadores (Flydesk)",
        searchPlaceholder: "Buscar por nome, ID, empresa...",
        refresh: "Atualizar",
        hint: "Cada computador aparece aqui depois que alguém entra no Flydesk nele. Bloquear tira o acesso sem apagar o registro; excluir libera uma licença.",
        empty: "Nenhum computador registrado ainda.",
        emptyHint:
          "Instale o Flydesk no computador e entre com o login da empresa — ele aparece aqui sozinho.",
        noResults: "Nenhum computador encontrado para essa busca.",
        noDevicesInCompany: "Esta empresa ainda não registrou nenhum computador.",
        online: "Online",
        offline: "Offline",
        blocked: "Bloqueado",
        unnamed: "Sem nome",
        never: "Nunca",
        justNow: "agora mesmo",
        minutesAgo: "há {{m}} min",
        hoursAgo: "há {{h}} h",
        daysAgo: "há {{d}} dias",
        licences: "licenças",
        unlimited: "Ilimitado",
        deviceCount: "{{n}} computador(es)",
        onlineCount: "{{n}} online",
        copyId: "Clique para copiar o ID",
        idCopied: "ID copiado!",
        blockedHelper: "Bloquear impede este computador de entrar",
        stats: {
          total: "Computadores",
          online: "Online agora",
          companies: "Empresas",
          blocked: "Bloqueados",
        },
        actions: {
          block: "Bloquear acesso",
          unblock: "Desbloquear",
          delete: "Excluir computador",
        },
        download: {
          title: "Instalar o Flydesk neste computador",
          description:
            "Baixe e instale. Ao abrir, entre com o mesmo e-mail e senha que você usa aqui — o computador aparece nesta lista automaticamente.",
          button: "Baixar para Windows",
        },
        table: {
          name: "Nome",
          deviceId: "ID",
          company: "Empresa",
          user: "Registrado por",
          status: "Situação",
          lastSeen: "Visto por último",
          blocked: "Bloqueado",
          actions: "Ações",
        },
        confirmDelete: {
          title: "Excluir computador",
          message:
            "O computador sai da lista e libera uma licença. Se alguém entrar nele de novo, ele volta a aparecer e consome licença outra vez.",
        },
        toasts: {
          updated: "Computador atualizado.",
          deleted: "Computador excluído.",
        },
      },
      companies: {
        details: {
          modulesTitle: "Módulos contratados",
          limitsTitle: "Limites e uso",
          devicesTitle: "Computadores no Flydesk",
          users: "Usuários",
          connections: "Conexões",
          devices: "PCs",
          unlimited: "sem limite",
          noDevices:
            "Nenhum computador registrado. Instale o Flydesk e entre com o login desta empresa.",
          edit: "Editar empresa",
        },
        title: "Empresas",
        searchPlaceholder: "Pesquisar...",
        buttons: {
          add: "Adicionar empresa",
          refresh: "Atualizar",
        },
        stats: {
          total: "Empresas",
          active: "Ativas",
          users: "Usuários",
        },
        table: {
          name: "Empresa",
          users: "Usuários",
          createdAt: "Criada em",
          actions: "Ações",
          default: "Padrão",
          status: "Status",
          connections: "Conexões",
          active: "Ativa",
          inactive: "Inativa",
          cannotDeleteDefault: "A empresa padrão não pode ser excluída",
          cannotDeactivateDefault: "A empresa padrão não pode ser desativada",
          empty: "Nenhuma empresa encontrada",
        },
        modal: {
          addTitle: "Nova empresa",
          editTitle: "Editar empresa",
          name: "Nome da empresa",
          adminName: "Nome do administrador",
          adminNameHelper: "Se vazio, usa o nome da empresa",
          email: "E-mail de acesso",
          password: "Senha",
          cancel: "Cancelar",
          save: "Salvar",
          adminSection: "Administrador da empresa",
          modulesSection: "Módulos contratados",
          moduleWhatsapp: "Atendimento WhatsApp",
          moduleWhatsappHelper: "Módulo base, incluído em todas as empresas",
          module_financeiro: "Financeiro",
          module_flydesk: "Flydesk (acesso remoto)",
          limitsSection: "Limites (opcional)",
          maxDevices: "PCs no Flydesk",
          maxDevicesHelper: "Quantos computadores esta empresa pode registrar. Vazio = ilimitado",
          maxUsersHelp:
            "Quantas PESSOAS desta empresa podem ter acesso ao sistema — cada atendente com seu próprio e-mail e senha.\n\nO administrador criado junto com a empresa já conta. Ex.: limite 5 = admin + 4 atendentes.\n\nAo atingir o limite, a empresa não consegue criar novos usuários. Quem já existe continua funcionando.",
          maxConnectionsHelp:
            "Quantos NÚMEROS de WhatsApp esta empresa pode conectar (cada QR Code lido é uma conexão).\n\nConexões do Modo Teste não contam.\n\nAo atingir o limite, a empresa não consegue adicionar outro número. Os já conectados continuam funcionando.",
          maxDevicesHelp:
            "Quantos COMPUTADORES esta empresa pode registrar no Flydesk para acesso remoto.\n\nO PC entra na conta quando alguém faz login no Flydesk nele pela primeira vez. Ao atingir o limite, o login é recusado com aviso.\n\nExcluir um PC na tela Acesso Remoto libera a vaga.",
          maxUsers: "Limite de usuários",
          maxConnections: "Limite de conexões",
          unlimitedHelper: "Vazio = ilimitado",
          status: "Empresa ativa",
          validation: {
            required: "Obrigatório",
            tooShort: "Muito curto",
            tooLong: "Muito longo",
            invalidEmail: "E-mail inválido",
            integer: "Use um número inteiro",
            limitMin: "Deve ser no mínimo 1",
          },
        },
        toasts: {
          saved: "Empresa salva com sucesso.",
          deleted: "Empresa excluída com sucesso.",
          activated: "Empresa ativada.",
          deactivated: "Empresa desativada.",
        },
        errors: {
          ERR_EMAIL_ALREADY_EXISTS: "Já existe um usuário com este e-mail.",
          ERR_CANNOT_DEACTIVATE_DEFAULT_COMPANY:
            "A empresa padrão não pode ser desativada.",
          ERR_USER_LIMIT_REACHED: "Limite de usuários da empresa atingido.",
          ERR_CONNECTION_LIMIT_REACHED:
            "Limite de conexões da empresa atingido.",
          ERR_COMPANY_INACTIVE:
            "Esta empresa está inativa. Contate o administrador do sistema.",
        },
        confirmationModal: {
          deleteTitle: "Excluir empresa",
          deleteMessage:
            "Esta ação apaga TODOS os dados da empresa: usuários, conexões, tickets e contatos. Não pode ser desfeita.",
        },
      },
      ticketsTeam: {
        hint: "Arraste um atendimento para transferi-lo entre atendentes ou de volta para a fila.",
        you: "você",
        waitingColumn: "Aguardando",
        dropHere: "Solte um atendimento aqui",
        transferredTo: "Atendimento transferido para",
        returnedToQueue: "Atendimento devolvido para a fila",
        noQueue: "Sem fila",
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldConnectionLabel: "Transferir para conexão",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldConnectionPlaceholder: "Selecione uma conexão",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum ticket encontrado com esse status ou termo pesquisado",
        connectionTitle: "Conexão que está sendo utilizada atualmente.",
        assignedTitle: "Atendente responsável por este atendimento.",
        groupMine: "Meus atendimentos",
        groupTeam: "Equipe",
        buttons: {
          accept: "Aceitar",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          tickets: "Atendimentos",
          contacts: "Contatos",
          quickAnswers: "Respostas Rápidas",
          financeiro: "Financeiro",
          flydesk: "Acesso Remoto",
          queues: "Filas",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
          testMode: "Modo Teste",
          superSection: "Plataforma",
          companies: "Empresas",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar fila",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os tickets dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
      },
      quickAnswers: {
        title: "Respostas Rápidas",
        table: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Resposta Rápida",
        },
        toasts: {
          deleted: "Resposta Rápida excluída com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Você tem certeza que quer excluir esta Resposta Rápida: ",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
      },
      users: {
        title: "Usuários",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
        pix: {
          title: "Pix da empresa",
          subtitle:
            "Cadastre a chave que os atendentes enviam no chat com /pix ou pelo botão R$.",
          key: "Chave Pix",
          name: "Nome do recebedor",
          nameHelper: "Nome que aparece para o cliente ao pagar",
          city: "Cidade",
          save: "Salvar Pix",
          saved: "Dados do Pix salvos com sucesso.",
          keyTypes: {
            phone: "Celular",
            random: "Chave aleatória",
          },
        },
      },
      pix: {
        buttonTooltip: "Enviar Pix (/pix)",
        keyTypes: {
          phone: "Celular",
          random: "Chave aleatória",
        },
        dialog: {
          title: "Enviar chave Pix",
          copyKey: "Copiar chave Pix",
          copied: "Chave Pix copiada!",
          send: "Enviar",
          sent: "Chave Pix enviada!",
          cancel: "Cancelar",
          hint: "O cliente recebe este cartão no WhatsApp com o botão de copiar.",
          notConfiguredTitle: "Pix ainda não configurado",
          notConfiguredAdmin:
            "Cadastre a chave Pix da empresa nas Configurações para enviá-la no chat.",
          notConfiguredUser:
            "Peça ao administrador para cadastrar a chave Pix da empresa nas Configurações.",
          goToSettings: "Ir para Configurações",
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem ou tecle ''/'' para utilizar as respostas rápidas cadastrada",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      ticketOptionsMenu: {
        delete: "Deletar",
        transfer: "Transferir",
        confirmationModal: {
          title: "Deletar o ticket do contato",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
      },
    },
  },
};

export { messages };
